import React from "react";

import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";

// eslint-disable-next-line react/prop-types
const PrivateRoute = ({ component: Component, isSouscription, ...rest }) => {

	// Permet de sécuriser l'accès à la route /conversation pour le B2C
	// Si le user n'a pas souscrit à une offre et par conséquent pas effectuer de paiement
	// ou s'il n'a pas entré de code d'activation il ne peut pas ouvrir une conversation avec un careManager

	return (
		<Route
			{...rest}
			render={props =>
				isSouscription ? (
					<Component {...props} />
				) : (
				// eslint-disable-next-line react/prop-types
					<Redirect to={{ pathname: "/", state: { from: props.location } }} />
				)
			}
		/>
	);
};

PrivateRoute.propTypes = {
	component: PropTypes.object,
	rest: PropTypes.string,
	isSouscription: PropTypes.bool,
	getSouscription: PropTypes.func,
	idExt: PropTypes.string,
};

export default PrivateRoute;
